import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'app/dialogs/dialog.service';
import { MimeTypesEnum, MimeTypesNames } from 'app/enums/mime-types.enum';
import { PanelsName } from 'app/enums/panels.enum';
import { ReportStatus, ReportType } from 'app/enums/report-panel.enum';
import { ConfirmDialogOptions } from 'app/models/confirm-dialog-options.models';
import { FileDto } from 'app/models/file';
import { GetReportFile, ReportNotification } from 'app/models/generate-report.model';
import { ReportService } from 'app/services/report.service';
import { ToastService } from 'app/services/toast.service';
import { Observable, of, Subject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
    selector     : 'reports-panel',
    templateUrl  : './reports-panel.component.html',
    styleUrls    : ['./reports-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ReportsPanelComponent implements OnInit, OnDestroy {

    @Input() refreshPanelDataObservable: Observable<void>;

    panelNames = PanelsName;
    reportStatuses = ReportStatus;
    reportTypes = ReportType;

    reportNotis: ReportNotification[];
    isLoading: boolean = false;
    @Output() loading: EventEmitter<boolean>;

    mimeTypes = MimeTypesEnum;
    mimeTypesNames = MimeTypesNames;
    knownMimeTypes: string[] = [this.mimeTypes.PDF, this.mimeTypes.ZIP]

    // filesMock: FileDto[] = [
    //     {
    //         id: 1,
    //         name: 'file n 1',
    //         mimeType: this.mimeTypes.PDF,
    //         fileLength: 100
    //     },
    //     {
    //         id: 2,
    //         name: 'file n 2 Lorem Ipsum file n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsumfile n 2 Lorem Ipsum',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 3,
    //         name: 'file n 3',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 4,
    //         name: 'file n 4',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 5,
    //         name: 'file n 5',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 6,
    //         name: 'file n 6',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 7,
    //         name: 'file n 7',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 8,
    //         name: 'file n 8',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 9,
    //         name: 'file n 9',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     },
    //     {
    //         id: 10,
    //         name: 'file n 10',
    //         mimeType: this.mimeTypes.ZIP,
    //         fileLength: 100
    //     }
    // ];
    

    /**
     * Constructor
     */
    constructor(
        private router: Router,
        private fuseSidebarService: FuseSidebarService,
        private reportService: ReportService,
        private dialogService: DialogService,
        private translateService: TranslateService,
        private toast: ToastService,
    ) {
        this.loading = new EventEmitter();
        this.reportService.reports$
          .subscribe(res => this.reportNotis = res);
    }

    ngOnInit(): void {
        this.refreshPanelDataObservable
            .pipe(
                tap(() => this.setLoading(true)),
                switchMap(() =>this.reportService.getReports())
            )
            .subscribe(
                reportNotis => {
                    this.reportNotis = reportNotis;
                    this.setLoading(false);
                },
                err => {
                    this.reportNotis = [];
                    this.setLoading(false);
                    let msg = this.translateService.instant("errors." + err.Extensions.ErrorCode);
                    this.toast.error("", msg);
                },
                () =>{
                    this.setLoading(false);   
                    this.reportNotis = [];
                }
            );
    }

    ngOnDestroy(): void {
        this.fuseSidebarService.getSidebar(this.panelNames.reportPanel).close();
    }

    setLoading (is: boolean): void {
        this.isLoading = is;
        this.loading.emit(this.isLoading);
    }

    checkMimeTypeLength(files: FileDto[], mimeType?: string): FileDto[] {
        if (mimeType) return files.filter(f => f.mimeType == mimeType);

        if(!mimeType) return files.filter(f => f.name.includes('.zip'));

        // return files.filter(f => !this.knownMimeTypes.some(mime => mime == f.mimeType));

    }

    getReportFiles (reportId:number, reportFiles: FileDto[], mimeType?: string): void {
        const filesByMimeType = this.checkMimeTypeLength(reportFiles, mimeType);

        if (filesByMimeType.length == 1) { 
            this.downloadReportFile(filesByMimeType[0].id, reportId);
            return;
        }

        this.dialogService.openFileListDialog(reportId, filesByMimeType, mimeType);
    }

    downloadReportFile (fileId:number, reportRequestId: number): void {
        const getReport: GetReportFile = {fileId, reportRequestId}
        this.reportService.downloadFileReport(getReport).subscribe();
    }

    showReportParameters(parameters){
        let parametersCleaned = parameters.split('||').filter(i => i !== "").join(', ');
        let options: ConfirmDialogOptions = {
            hideCancelButton: true
        }
        let title = this.translateService.instant("REPORTS.PARAMETERS")
        this.dialogService.openConfirmDialog(title, parametersCleaned, options);
    }
}
